module.exports = __webpack_public_path__ + "static/media/down-arrow-white.0bb73486.svg";